import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CoreApiService } from 'app/shared/services/common/core-api-service';
import { Observable, throwError } from 'rxjs';
import { ClientContactAssociation, ClientContactFormModel } from './client-contact.model';

@Injectable({
    providedIn: 'root'
})
export class ClientContactService extends CoreApiService<ClientContactAssociation> {
    constructor(protected httpService: HttpClient) {
        super(httpService, 'data/client-contact');
    }

    updateAssociation(association: ClientContactAssociation): Observable<ClientContactAssociation> {
        if (!association?.id) {
            return throwError(() => new Error('A client contact can only be updated by its own association id.'));
        }

        return this.patch(association.id, association);
    }

    createAssociation(association: Omit<ClientContactAssociation, 'id'>): Observable<ClientContactAssociation> {
        return this.create(association as ClientContactAssociation);
    }

    updateFromFormModel(model: ClientContactFormModel): Observable<ClientContactAssociation> {
        return this.updateAssociation({
            id: model.id,
            clientId: model.clientId,
            contactId: model.contactId ?? model.tempContactId,
            apRep: model.apRep,
            emailContact: model.emailContact,
            managementRep: model.managementRep,
            mmrId: model.mmrId,
            userRequested: model.userRequested
        });
    }
}
